import React from "react";
import { Alert } from "react-bootstrap";

export default function NoDepartmentReportNotice() {
  return (
    <Alert variant="info" className="py-2 mb-3 small">
      No department report exists for this reporting period yet. Submitting an activity
      entry will automatically create a draft report, or you can add notes below and use
      Save Draft to create one.
    </Alert>
  );
}
